export const buildClearProducts = () => [];
